import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { CommonUtil } from '../../core/Utils/common-util';
import { PreviewModalData } from './preview-modal.model';

@Component({
  selector: 'app-preview-modal',
  templateUrl: './preview-modal.component.html',
  styleUrls: ['./preview-modal.component.css']
})
export class PreviewModalComponent implements OnInit {
  rootScopeData: RootScopeDeclare;
  selectedPreviewData: PreviewModalData;
  @Input() modalTitle: string;
  @Input() currentConsole: string;
  @Input() previewData: PreviewModalData[];
  @Output() callOnNegativeBtnClick: EventEmitter<string> = new EventEmitter();
  cloudBasePath: string;

  constructor(private _commonUtil: CommonUtil) {
  }

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.rootScopeData = this._commonUtil.rootScopeData;
    if(this.previewData) this.selectedPreviewData = this.previewData[0];
  }

  onNegativeButtonClick(): void {
    this.callOnNegativeBtnClick.emit();
  }
  
  stopBubbling(e: Event) {
    e.stopPropagation();
  }
}
